import React from 'react';
import EnabledServices from '../components/sections/solutions/EnabledServices';
import ConsultationServices from '../components/sections/solutions/ConsultationServices';
import CloudSolutions from '../components/sections/solutions/CloudSolutions';
import InfrastructurePlanning from '../components/sections/solutions/InfrastructurePlanning';
import SolutionsCallToAction from '../components/sections/solutions/SolutionsCallToAction';

const Solutions = () => {
  return (
    <>
      <EnabledServices />
      <ConsultationServices />
      <InfrastructurePlanning />
      <CloudSolutions />
      <SolutionsCallToAction />
    </>
  );
};

export default Solutions;